import React from 'react';
import { CreatorEntriesInput, CreatorEntryItem } from './CreatorEntriesInput';

interface CreatorEntriesFieldProps {
  label: string;
  required?: boolean;
  value?: CreatorEntryItem[];
  onChange: (_value: CreatorEntryItem[]) => void;
  error?: string;
}

export const CreatorEntriesField: React.FC<CreatorEntriesFieldProps> = ({
  label,
  required = false,
  value = [],
  onChange,
  error,
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <CreatorEntriesInput value={value} onChange={onChange} />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </>
  );
};
